// Thin StandUp API wrapper. Centralises the endpoint surface so the pages
// stay focused on render + state and we can swap the polling cadence in one
// place if we ever decide to graduate to WebSockets.
import { api } from "@/lib/api";

export const standupApi = {
  // Templates + reference
  templates: (methodology) => api.get("/standup/templates", { params: methodology ? { methodology } : {} }),
  saveTemplate: (payload) => api.post("/standup/templates", payload),
  backgrounds: () => api.get("/standup/backgrounds"),
  limits: () => api.get("/standup/limits"),

  // Standup definitions
  create: (payload) => api.post("/standup", payload),
  listMine: () => api.get("/standup/mine"),
  get: (id) => api.get(`/standup/${id}`),
  update: (id, payload) => api.put(`/standup/${id}`, payload),
  remove: (id) => api.delete(`/standup/${id}`),
  invite: (id, payload) => api.post(`/standup/${id}/invite`, payload),

  // Magic link (public)
  resolveMagic: (token) => api.get(`/standup/j/${token}/resolve`),

  // Sessions
  createSession: (standupId) => api.post(`/standup/${standupId}/session`),
  activeSessions: () => api.get("/standup/sessions/active"),
  startSession: (sid) => api.post(`/standup/session/${sid}/start`),
  addItem: (sid, payload) => api.post(`/standup/session/${sid}/items`, payload),
  timer: (sid, payload) => api.post(`/standup/session/${sid}/timer`, payload),
  submitList: (sid, payload) => api.post(`/standup/session/${sid}/list`, payload),
  myList: (sid) => api.get(`/standup/session/${sid}/list/me`),
  progress: (sid) => api.get(`/standup/session/${sid}/progress`),

  // Lobby
  lobbyRequest: (sid, payload) => api.post(`/standup/session/${sid}/lobby/request`, payload),
  lobby: (sid) => api.get(`/standup/session/${sid}/lobby`),
  admit: (sid, email) => api.post(`/standup/session/${sid}/lobby/${encodeURIComponent(email)}/admit`),
  deny: (sid, email) => api.post(`/standup/session/${sid}/lobby/${encodeURIComponent(email)}/deny`),
  // Daily quote
  quoteToday: (sessionId) => api.get("/standup/quotes/today", { params: sessionId ? { session_id: sessionId } : {} }),

  // Phase 4 — End + Summary + Share + Gantt markers
  endSession: (sid) => api.post(`/standup/session/${sid}/end`),
  summary: (sid) => api.get(`/standup/session/${sid}/summary`),
  shareSummary: (sid, payload) => api.post(`/standup/session/${sid}/summary/send`, payload),
  emailMeSummary: (sid) => api.post(`/standup/session/${sid}/summary/email-me`),
  ganttMarkers: (projectId, taskId) => api.get("/standup/gantt/markers", { params: taskId ? { project_id: projectId, task_id: taskId } : { project_id: projectId } }),
};

// Polling cadence — bump up during active item timer if we ever want sub-second updates.
export const POLL_MS = 3000;
